// extracted by css-extract-rspack-plugin
export default {"header":"header-Ecq4nU","headerContent":"headerContent-qwvWIo max-w-content mx-auto","title":"title-Gb1woQ text-headline-md"};